import * as React from 'react';

export type Props = React.PropsWithChildren & JSX.IntrinsicElements['div'];

function Area(props: Props) {
  const { children, ...rest } = props;
  const [show, setShow] = React.useState(false);
  React.useEffect(() => {
    setShow(true);
  }, []);
  console.log('Area', { show });
  return show ? (
    <div
      style={{ border: '1px solid', borderRadius: '4px', width: '100%', height: '300px', marginBottom: '1rem' }}
      {...rest}
    >
      {children}
    </div>
  ) : (
    <></>
  );
}

export default React.memo(Area);
